<template>
	<div class="container-fluid">
		<service-contract-toolbar :customer-name="customerName"></service-contract-toolbar>

		<div class="row">
			<div class="col-md-6">
				<widget class="form" title="Products Added to Contract">

					<ul class="list-group" v-if="addedProducts.length > 0">
						<li v-for="(product,index) in addedProducts" class="list-group-item list-group-item-action bg-light" >
							<div class="d-flex justify-content-between product-heading align-items-center" v-on:click="expandCollapseProduct('added',product.id)">
								<h3 class="product-title">{{product.title}}</h3>

								<span>Qty: {{product.qty}}</span>

								<i class="fa icon-button" :class="{'fa-chevron-down': !product.expanded, 'fa-chevron-up': product.expanded}"></i>
							</div>

							<div v-if="product.expanded" class="expanded-container">

								<div class="d-flex flex-wrap align-items-center justify-content-between">
									<div><span class="price">${{product.price}}</span>/annually</div>

									<div class="d-flex align-items-center">
										<label class="mr-2 mb-0">Qty</label>
										<field style="width: 80px;"
											:params="{type:'number',min:1,step:1}"
											v-model="product.qty"
											v-on:change="qtyChange($event,index)">
										</field>
									</div>
								</div>

								<div v-html="stripInlineEventHandlers(product.description)"></div>

								<button type="button" class="btn btn-sm btn-outline-danger" v-on:click="removeProduct(index)">
									<i class="fa fa-trash"></i>
									Remove
								</button>
							</div>
						</li>
					</ul>
					<p v-else>Add products to the contract by clicking the <i class="fa fa-plus"></i> button on a product in the right column</p>

					<info-box class="mt-2" label="Total Cost of Contract" :value="totalCost"></info-box>
				</widget>
			</div>
			<div class="col-md-6">
				<widget class="form" title="Offered Products">

					<ul class="list-group">
						<li v-for="product in products" class="list-group-item list-group-item-action bg-light">
							
							<div class="d-flex justify-content-between product-heading align-items-center" v-on:click="expandCollapseProduct('available',product.id)">
								<div class="d-flex align-items-center">
									<button class="btn btn-light mr-2" type="button" v-on:click="addProduct(product.id)">
										<i class="fa fa-plus"></i>
									</button>
									<h3 class="product-title">{{product.title}}</h3>
								</div>

								<i class="fa icon-button" :class="{'fa-chevron-down': !product.expanded, 'fa-chevron-up': product.expanded}"></i>
							</div>

							<div v-if="product.expanded" class="expanded-container">
								<div><span class="price">${{product.price}}</span>/annually</div>
								<div v-html="stripInlineEventHandlers(product.description)"></div>
							</div>
						</li>
					</ul>

				</widget>
			</div>
		</div>

	</div>
</template>
<script type="text/javascript">
import InfoBox from "@/components/InfoBox"
import Widget from "@/components/Widget"
import Field from "@/components/Field"

import ServiceContractToolbar from "./ServiceContractToolbar"
import ServiceContractMixins from "@/mixins/ServiceContractMixins.js"

export default {
	name: "ServiceContractProducts",
	components: {
		ServiceContractToolbar,
		InfoBox,
		Widget,
		Field
	},
	mixins: [ServiceContractMixins],
	data() {
		return {
			working: false,
			products: [],
			addedProducts: []
		}
	},
	computed: {
		totalCost() {
			return "$"+this.addedProducts.reduce((acc,item) => acc + (+item.price * +item.qty),0).toCurrency()
		}
	},
	methods: {
		mutateProducts(products) {
			let vm = this

			return products.map(product => {
				product.expanded = false

				return product
			})
		},
		removeProduct(index) {
			let vm = this
			let product = this.addedProducts[index]

			let payload = {
				id: product.lookup_record_id
			}
			this.postData("ServiceContractProduct/delete",payload,true).then(response => {
				if (response.success)
					vm.addedProducts.splice(index,1)
			})
		},
		addProduct(product_id) {
			//check if already added, if so add 1 to qty
			let index = this.addedProducts.findIndex(product => product.id == product_id)
			if (index >= 0) {
				this.addedProducts[index].qty++

				let payload = {
					id: this.addedProducts[index].lookup_record_id,
					qty: this.addedProducts[index].qty
				}

				this.postData("ServiceContractProduct/save",payload,true)
			}
			else {
				let product = this.products.find(prod => prod.id == product_id)
				if (product) {
					let cloned = this.cloneObj(product)
					cloned.qty = 1
					this.addedProducts.push(cloned)

					let payload = {
						service_contract_id: this.$store.serviceContract.id,
						product_id,
						qty: 1
					}
					this.postData("ServiceContractProduct/save",payload,true)
				}
			}
		},
		qtyChange(qty,product_index) {
			let payload = {
				id: this.addedProducts[product_index].lookup_record_id,
				qty
			}

			this.postData("ServiceContractProduct/save",payload,true)
		},
		expandCollapseProduct(list,product_id,expand) {
			let key = "products"
			if (list == 'added') 
				key = "addedProducts"

			let index = this[key].findIndex(product => product.id == product_id)

			if (index >= 0)
				this[key][index].expanded = !this[key][index].expanded

			this.$forceUpdate()
		},
		fetchProducts(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			this.getJSON("ServiceProduct/get").then(response => {
				if (spinner)
					vm.spinner(false)

				if (response.success)
					vm.products = vm.mutateProducts(response.data)
			})
		}
	},
	created() {
		let vm = this
		this.fetchContractIfNotSet(this.$route.params.slug).then(response => {
			vm.addedProducts = response.data.ServiceProduct
			vm.fetchProducts(true)
		})
	}
}
</script>
<style type="text/css" scoped>
	.product-heading {
		margin: -11px;
		margin-left: -20px;
		margin-right: -20px;
		padding: 15px;
		background-color: white;
		cursor: pointer;
	}

	.expanded-container {
		margin-top: 30px;
	}

	.price {
		font-size: 18pt;
	}

	.product-title {
		margin: 0;
	}
</style>